import { render, staticRenderFns } from "./ComparisonTableGroupAssumptions.vue?vue&type=template&id=3bc71a45&"
import script from "./ComparisonTableGroupAssumptions.vue?vue&type=script&lang=js&"
export * from "./ComparisonTableGroupAssumptions.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports